import { IDataResListDataTransfer, IParamListDataTransfer, ITransfer, ITransferDeposit } from '@interfaces/Transfer';
import httpRequest from './Api';

/** Đảm bảo query có cả giá trị 0 (transfer_type=0) — axios mặc định có thể bỏ sót. */
function serializeParams(params: Record<string, unknown> | undefined): string {
  const parts: string[] = [];
  if (!params) {
    return '';
  }
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  });
  return parts.join('&');
}

const Transfer = {
  getAllTransfer({ ...rest }: Partial<IParamListDataTransfer>): Promise<IDataResListDataTransfer<ITransfer>> {
    const url = '/list-transfer-moneys';
    return httpRequest.get(url, {
      params: rest as Record<string, unknown>,
      paramsSerializer: serializeParams,
    });
  },

  deposit({ ...rest }: Partial<ITransferDeposit>): Promise<{ messages: string; data?: { transfer_id?: number; bill_no?: string } }> {
    const url = '/create-transfer-money';
    return httpRequest.post(
      url,
      { ...rest },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  attachTransferMoneyImages(payload: { transfer_id: number; images: File[] }): Promise<{ messages: string }> {
    const url = '/attach-transfer-money-images';
    const formData = new FormData();
    formData.append('transfer_id', String(payload.transfer_id));
    payload.images.forEach((file) => {
      formData.append('images', file);
    });
    return httpRequest.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default Transfer;
